/**
 * Ürün Sekmeleri JavaScript
 * Bu dosya ürün sekmeleri için etkileşimli işlevselliği sağlar
 */

(function() {
  document.addEventListener("DOMContentLoaded", function() {
    initTabs();
  });

  function initTabs() {
    const tabContainers = document.querySelectorAll(".tab-container");
    
    tabContainers.forEach(function(container) {
      
      // ── MASAÜSTÜ SEKME İŞLEVİ ──────────────────────────────────────────
      // CSS: aktif olmayan .tab-content → position:absolute, visibility:hidden
      //      aktif .tab-content → position:relative, visibility:visible
      // Böylece display değişmez → layout shift / titreme yok
      const desktopContainer = container.querySelector(".desktop-tabs-content");
      if (desktopContainer) {
        const desktopTabs = desktopContainer.querySelectorAll(".tab");
        const tabContents = desktopContainer.querySelectorAll(".tab-content");

        for (let i = 0; i < desktopTabs.length; i++) {
          desktopTabs[i].addEventListener("click", function(e) {
            e.preventDefault();

            // Butonlar
            for (let j = 0; j < desktopTabs.length; j++) {
              desktopTabs[j].classList.remove("active");
            }
            this.classList.add("active");

            // İçerikler
            const tabToShow = this.getAttribute("data-tab");
            for (let j = 0; j < tabContents.length; j++) {
              tabContents[j].classList.remove("active");
            }
            const contentToShow = desktopContainer.querySelector(".tab-content[data-tab='" + tabToShow + "']");
            if (contentToShow) {
              contentToShow.classList.add("active");
            }
          });
        }
      }

      // ── MOBİL AKORDİYON İŞLEVİ ────────────────────────────────────────
      const mobileContainer = container.querySelector(".tabs-mobile");
      if (mobileContainer) {
        const accordionTabs = mobileContainer.querySelectorAll(".accordion-tab");
        
        for (let i = 0; i < accordionTabs.length; i++) {
          accordionTabs[i].addEventListener("click", function(e) {
            e.preventDefault();

            const tabId   = this.getAttribute("data-tab");
            const content = document.getElementById(tabId);
            // accordion-item wrapper: border + radius burada kontrol edilir
            const item    = this.closest(".accordion-item");
            
            if (this.classList.contains("active")) {
              // Kapat
              this.classList.remove("active");
              if (content) {
                content.classList.remove("active");
                content.style.maxHeight = null;
              }
              if (item) item.classList.remove("is-open");
            } else {
              // Aç
              this.classList.add("active");
              if (content) {
                content.classList.add("active");
                content.style.maxHeight = content.scrollHeight + "px";
              }
              if (item) item.classList.add("is-open");
            }
          });
        }
        
        window.addEventListener("resize", function() {
          const openContents = mobileContainer.querySelectorAll(".accordion-content.active");
          openContents.forEach(function(c) {
            c.style.maxHeight = c.scrollHeight + "px";
          });
        });
      }
    });
  }
})();
